import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

/**
 * Create a React Dropdown List Group Item component
 *
 * @template T
 * @param {import('./interfaces').DropdownListGroupItemProps<T>} props
 * @returns {JSX.Element}
 */
function DropdownListGroupItem ({
  id,
  onClick,
  label,
  children,
  group,
  groupIndex
}) {
  const handleClick = useCallback(event => {
    onClick(group, groupIndex, event)
  })
  // Using `group` role, according to
  // WAI-ARIA 1.2 W3C Editor's Draft 02 May 2019
  // https://github.com/w3c/aria/commit/71cc98e0ac2fd816bce615de9a62b30c33e974f5
  return (
    <div className='zb-dropdown-list-group' role='group' aria-labelledby={label && id}>
      {label && <span
        className='zb-dropdown-list-group-label'
        onClick={handleClick}
        id={id}
      >
        {label}
      </span>}
      <ul className='zb-dropdown-list-group-items' role='group'>
        {children}
      </ul>
    </div>
  )
}

DropdownListGroupItem.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  group: PropTypes.any,
  groupIndex: PropTypes.number
}

export default DropdownListGroupItem
